// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"3265c0cb","110":"74bc4dad","138":"2b5b0384","392":"555584ca","453":"be0bfe49","530":"fff03bc1","659":"aabe1cf3","804":"3d44633c","915":"04df8411","934":"aeda5956"}[chunkId] + ".chunk.js";
};